export class ContactsItemModel {
    id: number;
    name: string;
    address: string;
    title: string;
    phoneNumber: string;
    mobileNumber: string;
    emailAddress: string;
    webAddress: string;
    imageData?: string;
    imageId?: string;
    validEmail?: boolean;
}
